<script>
  import {onMount, onDestroy} from 'svelte'
  import gsap from 'gsap'
  import ScrollTrigger from 'gsap/ScrollTrigger'
  import AnimatedTitle from '../components/AnimatedTitle.svelte'
  import AnimatedLine from '../components/AnimatedLine.svelte'
  import AnimatedBlock from '../components/AnimatedBlock.svelte'

  import PlusMore from '../svgs/PlusMore.svelte'
  import Hulu from '../svgs/Hulu.svelte'
  import Tubi from '../svgs/Tubi.svelte'
  import Pluto from '../svgs/Pluto.svelte'
  import Discovery from '../svgs/Discovery.svelte'
  import AMC from '../svgs/AMC.svelte'
  import Disney from '../svgs/Disney.svelte'
  import ESPN from '../svgs/ESPN.svelte'
  import Viacom from '../svgs/Viacom.svelte'
  import NBC from '../svgs/NBC.svelte'
  import Fox from '../svgs/Fox.svelte'
  import CW from '../svgs/CW.svelte'
  import Xumo from '../svgs/Xumo.svelte'

  let part3a, part3b, tl, triggers = []

  // $: if(clientHeight > 0) {
  //   ScrollTrigger.refresh(true)
  // }

  onMount(() => {
    part3a.querySelectorAll('.icon').forEach(icon => {
      const tl = gsap.from(icon, {
        opacity: 0,
        y: 30,
        force3D: true,
        ease: 'power2.out',
        duration: 0.75,
      })
      const st = ScrollTrigger.create({
        trigger: icon,
        start: 'top 70%',
        end: '+=100',
        animation: tl,
        toggleActions: 'play play play pause'
      })
      triggers.push(st)
    })
    const tl = gsap.from(part3b.querySelectorAll('.icon'), {
      opacity: 0,
      scale: 0.85,
      force3D: true,
      ease: 'power2.out',
      stagger: {
        amount: .5,
        from: 'random',
        grid: 'auto',
      }
    })
    const st = ScrollTrigger.create({
      trigger: part3b.querySelector('.icons'),
      start: 'top center',
      end: '+=100',
      animation: tl,
      toggleActions: 'play play play pause'
    })
    triggers.push(st)

    /* ScrollTrigger.create({
      trigger: part3b.querySelector('.line-top'),
      start: 'top 66%',
      onEnter: moveIconsDown,
      onLeaveBack: moveIconsUp
    }) */
    
  })

  function moveIconsDown () {
    if(tl) tl.kill()
    if(!part3b) return
    tl = gsap.timeline()
    tl.fromTo(part3b.querySelector('.line-top'), {scaleX: 0, opacity: 0}, {scaleX: 1, opacity: 1, duration: 0.5, ease: 'power2.out'}, 0)
    tl.fromTo(part3b.querySelector('p.name'), {y: 30, opacity: 0}, {y: 0, opacity: 1, duration: 0.5, ease: 'power2.out'}, 0.15)
    tl.fromTo(part3b.querySelector('.line-bot'), {scaleX: 0, opacity: 0}, {scaleX: 1, opacity: 1, duration: 0.5, ease: 'power2.out'}, 0.5)
    part3b.querySelectorAll('.icon').forEach((icon, index) => {
      const id = icon.dataset.name
      const iconAbove = part3a.querySelector(`.icon[data-name="${id}"]`)
      const svgA = iconAbove.querySelector('svg'),
            svgB = icon.querySelector('svg'),
            rectA = svgA.getBoundingClientRect(),
            rectB = svgB.getBoundingClientRect(),
            diffX = rectA.x - rectB.x,
            diffY = rectA.y - rectB.y
      tl.fromTo(svgB,
        {x: diffX, y: diffY, opacity: 1},
        {x: 0, y: 0, opacity: 1, ease: 'power2.out', duration: 0.5,
          onComplete: () => {
            svgB.style.cssText = 'opacity: 1'
          },
          onStart: () => {
            gsap.set(svgA, {opacity: 0})
          }
      }, index * .05)
    })
  }
  
  function moveIconsUp () {
    if(tl) tl.kill()
    if(!part3b) return

    tl = gsap.timeline()
    tl.to(part3b.querySelector('.line-top'), {scaleX: 0, opacity: 0, duration: 0.5, ease: 'power2.in'}, 0.3)
    tl.to(part3b.querySelector('p.name'), {y: 30, opacity: 0, duration: 0.5, ease: 'power2.in'}, 0.15)
    tl.to(part3b.querySelector('.line-bot'), {scaleX: 0, opacity: 0, duration: 0.5, ease: 'power2.in'}, 0)
    part3b.querySelectorAll('.icon').forEach((icon, index) => {
      const id = icon.dataset.name
      const iconAbove = part3a.querySelector(`.icon[data-name="${id}"]`)
      const svgA = iconAbove.querySelector('svg'),
            svgB = icon.querySelector('svg'),
            rectA = svgA.getBoundingClientRect(),
            rectB = svgB.getBoundingClientRect(),
            diffX = rectA.x - rectB.x,
            diffY = rectA.y - rectB.y
      tl.to(svgB,
        {x: diffX, y: diffY, ease: 'power2.inOut', duration: 0.5,
          onComplete: () => {
            svgA.style.cssText = ''
            svgB.style.cssText = ''
          },
          onStart: () => {
            gsap.set(svgA, {opacity: 0})
          }
      }, index * .05)
    })
  }

  onDestroy(() => {
    triggers.map(st => st?.kill() )
  })

</script>
<section class="part3a" bind:this={part3a}>
  <div class="rgrid-md-1-2">
    <div class="col">
      <AnimatedTitle class="medium">From fragmentation...</AnimatedTitle>
      <AnimatedBlock><p class="desc">Traditionally, Upfront buys are highly fragmented and siloed, which leads to a convoluted activation process. </p></AnimatedBlock>
    </div>
  </div>
  <div class="rgrid-md-1-3">
<!--     <div class="bucket">
      <AnimatedLine size={1} />
      <AnimatedBlock><p class="name">Linear TV</p></AnimatedBlock>
      <div class="icons">
        <div class="icon" data-name="dish"><Dish /></div>
        <div class="icon" data-name="fios"><Fios /></div>
      </div>
    </div> -->
    <div class="bucket">
      <AnimatedLine size={1} />
      <AnimatedBlock><p class="name">AVOD/SVOD Platforms</p></AnimatedBlock>
      <div class="icons">
        <div class="icon" data-name="hulu"><Hulu /></div>
        <div class="icon" data-name="tubi"><Tubi /></div>
        <div class="icon" data-name="pluto"><Pluto /></div>
        <div class="icon" data-name="xumo"><Xumo /></div>
      </div>
    </div>
    <div class="bucket col2-3">
      <AnimatedLine size={1} />
      <AnimatedBlock><p class="name">OTT/CTV Networks</p></AnimatedBlock>
      <div class="icons">
        <div class="icon" data-name="discovery"><Discovery /></div>
        <div class="icon" data-name="amc"><AMC /></div>
        <div class="icon" data-name="disney"><Disney /></div>
        <div class="icon" data-name="espn"><ESPN /></div>
        <div class="icon" data-name="viacom"><Viacom /></div>
        <div class="icon" data-name="nbc"><NBC /></div>
        <div class="icon" data-name="fox"><Fox /></div>
        <div class="icon" data-name="cw"><CW /></div>
      </div>
      <AnimatedLine size={1} />
    </div>
  </div>
</section>
<section class="part3b" bind:this={part3b}>
  <div class="rgrid-md-1-2">
    <div class="col">
      <AnimatedBlock useChildren={true}>
        <h1 class="medium">...to consolidation.</h1>
        <p class="desc end-txt">By activating your Upfronts programmatically, you can manage all of your deals and creatives in one easy-to-use platform.</p>
      </AnimatedBlock>
    </div>
  </div>
  <AnimatedLine size={3} desktopSize={5} color="red" class="line-top" />
  <AnimatedBlock><p class="name">Verizon Media DSP</p></AnimatedBlock>
  <div class="icons">
    <div class="icon" data-name="hulu"><Hulu /></div>
    <div class="icon" data-name="tubi"><Tubi /></div>
    <div class="icon" data-name="discovery"><Discovery /></div>
    <div class="icon" data-name="amc"><AMC /></div>
    <div class="icon" data-name="espn"><ESPN /></div>
    <div class="icon" data-name="viacom"><Viacom /></div>
    <div class="icon" data-name="fox"><Fox /></div>
    <div class="icon" data-name="nbc"><NBC /></div>
    <div class="icon" data-name="disney"><Disney /></div>
    <div class="icon" data-name="cw"><CW /></div>
    <div class="icon" data-name="pluto"><Pluto /></div>
    <div class="icon" data-name="xumo"><Xumo /></div>
    <div class="icon plus-more" data-name="plus"><PlusMore /></div>
  </div>
  <AnimatedLine size={1} color="red" start="top bottom-=50" />
</section>

<style>
  .part3a :global(.name),
  .part3b :global(.name) {
    font-size: 0.875rem;
    margin: 1.25rem 0 0;
    font-weight: 500;
  }
  section :global(.desc) {
    margin: .75rem 0 2.5rem;
  }
  .icons {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 0 0 50px;
  }
  .icon {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
  }
  .part3b .icon {
    width: 33.333%
  }
  .part3b :global(.name) {
    font-weight: 500;
  }
  .part3b :global(.end-txt) {
    margin-top: 1.5rem;
  }
  .part3b {
    margin-bottom: 10rem;
  }
  .plus-more {
    display: none
  }
  @media(min-width: 768px) {
    .bucket {
      border: 1px solid var(--gray-line);
      padding: var(--gutter-lg);
    }
    .bucket :global(.hline) {
      display: none;
    }
    .bucket :global(.name) {
      margin-top: 0;
    }
    .part3a .icon {
      min-height: 40px;
    }
    .part3b .icon {
      width: 25%
    }
    .col2-3 {
      grid-column: span 2;
    }
    .part3a .icons {
      padding-bottom: 20px;
    }
  }
  @media(min-width: 1024px) {
    .part3b .icon {
      width: 16.6666%
    }
    .col2-3 .icon {
      width: 33.3333%;
    }
    .plus-more {
      display: none
    }
  }
  @media(min-width: 1272px) {
    .col2-3 .icon {
      width: 25%;
    }
  }
</style>